'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byIndex = {
  fieldName: 'columnIndex',
  getColumn: function getColumn(columns, sortingColumnKey) {
    return columns[sortingColumnKey];
  }
};

var byProperty = {
  fieldName: 'property',
  getColumn: function getColumn(columns, property) {
    return (0, _find2.default)(columns, { property: property });
  }
};

exports.default = {
  byIndex: byIndex,
  byProperty: byProperty
};


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-sort/dist/strategies.js
// module id = 111
// module chunks = 0